import React, {ChangeEvent, useState, useEffect} from "react"
import {injectIntl, InjectIntl} from "@irati/utils/lang"
import FilterCheckboxOption from "@irati/deals/types/FilterCheckboxOption"

import {StyledFilterBy} from "../../containers/Deals/styled"

type Option = {
  uuid: string
  name: string
  value: string[]
}

export interface DealsTypeFilterProps extends InjectIntl {
  options: Option[]
  typeFromQuery?: string
  applyFilter: (selectedTypeUuid: string) => void
}

const initState = (options: Option[], typeFromQuery?: string): FilterCheckboxOption[] =>
  options.map((option) => {
    option.isChecked = isChecked(option.uuid, typeFromQuery)
    return option
  })

const isChecked = (optionUuid: string, type?: string) => !type || type === optionUuid

const DealTypesFilter: React.FC<DealsTypeFilterProps> = ({options, typeFromQuery, applyFilter, formatMessage}) => {
  const [filterOpts, setFilterOpts] = useState(() => initState(options, typeFromQuery))
  const [updateLabel, setUpdateLabel] = useState(() => () => {})

  useEffect(() => {
    setFilterOpts(initState(options, typeFromQuery))
    updateLabel()
  }, [typeFromQuery, options])

  const handleSelectFilter = ({target}: ChangeEvent<HTMLInputElement>, {selectAll = false}) => {
    const checkedFilterOptions = filterOpts.map((option) => {
      if (`${option.value}` === target.id || selectAll) {
        option.isChecked = target.checked
      }

      return option
    })

    setFilterOpts(checkedFilterOptions)
  }

  const handleResetFilter = () => {
    const checkedFilterOptions = filterOpts.map((option) => {
      option.isChecked = isChecked(option.uuid, typeFromQuery)
      return option
    })

    setFilterOpts(checkedFilterOptions)
  }

  const handleApplyFilter = () => {
    const checkedFilterOptions = filterOpts.filter((option) => option.isChecked)
    const allOptionsSelected = checkedFilterOptions.length === filterOpts.length

    const selectedOptionUuid = !allOptionsSelected ? checkedFilterOptions[0].uuid : ""

    applyFilter(selectedOptionUuid)
  }

  return (
    <StyledFilterBy
      setUpdateLabel={setUpdateLabel}
      id="filter_deals-type"
      loadFilterOptions={null}
      filterOptions={filterOpts}
      allOptionsSelectedLabel={formatMessage({id: "perks.fields.filterBy.dealType.allOptionsSelected.label"})}
      multipleOptionsSelectedLabel="perks.categories.filterBy.locations.multipleOptionsSelected.label"
      allOptionText={formatMessage({id: "perks.fields.filterBy.dealType.allOptions.text"})}
      resetButtonText={formatMessage({id: "perks.categories.checkboxGroup.reset.buttonText"})}
      saveButtonText={formatMessage({id: "perks.categories.checkboxGroup.save.buttonText"})}
      onSelect={(e) => handleSelectFilter(e, {selectAll: false})}
      onSelectAll={(e) => handleSelectFilter(e, {selectAll: true})}
      onReset={() => handleResetFilter()}
      onFilter={() => handleApplyFilter()}
    />
  )
}

export default injectIntl(DealTypesFilter)
